// Website Theme Management - Public Website Only

export const colorSchemes = [
  {
    id: 'default',
    name: 'Deep Purple Pro',
    primary: '#4C1D95',
    secondary: '#7C3AED',
    background: '#0F0A1A',
    text: '#FFFFFF',
    accent: '#8B5CF6',
    hover: '#5B21B6',
  },
  {
    id: 'midnight-blue',
    name: 'Midnight Blue',
    primary: '#1E3A8A',
    secondary: '#3B82F6',
    background: '#0F172A',
    text: '#F8FAFC',
    accent: '#2563EB',
    hover: '#1D4ED8',
  },
  {
    id: 'emerald-pro',
    name: 'Emerald Professional',
    primary: '#065F46',
    secondary: '#059669',
    background: '#064E3B',
    text: '#ECFDF5',
    accent: '#10B981',
    hover: '#047857',
  },
  {
    id: 'crimson-elite',
    name: 'Crimson Elite',
    primary: '#991B1B',
    secondary: '#DC2626',
    background: '#7F1D1D',
    text: '#FEF2F2',
    accent: '#EF4444',
    hover: '#B91C1C',
  },
  {
    id: 'golden-luxury',
    name: 'Golden Luxury',
    primary: '#92400E',
    secondary: '#D97706',
    background: '#78350F',
    text: '#FFFBEB',
    accent: '#F59E0B',
    hover: '#B45309',
  },
  {
    id: 'steel-gray',
    name: 'Steel Gray Pro',
    primary: '#374151',
    secondary: '#6B7280',
    background: '#1F2937',
    text: '#F9FAFB',
    accent: '#9CA3AF',
    hover: '#4B5563',
  },
  {
    id: 'ocean-depth',
    name: 'Ocean Depth',
    primary: '#0C4A6E',
    secondary: '#0284C7',
    background: '#0A2540',
    text: '#F0F9FF',
    accent: '#0EA5E9',
    hover: '#0369A1',
  },
  {
    id: 'royal-indigo',
    name: 'Royal Indigo',
    primary: '#3730A3',
    secondary: '#6366F1',
    background: '#312E81',
    text: '#EEF2FF',
    accent: '#8B5CF6',
    hover: '#4338CA',
  },
  {
    id: 'forest-dark',
    name: 'Forest Dark',
    primary: '#14532D',
    secondary: '#16A34A',
    background: '#052E16',
    text: '#F0FDF4',
    accent: '#22C55E',
    hover: '#15803D',
  },
  {
    id: 'corporate-navy',
    name: 'Corporate Navy',
    primary: '#1E293B',
    secondary: '#475569',
    background: '#0F172A',
    text: '#F1F5F9',
    accent: '#64748B',
    hover: '#334155',
  },
  {
    id: 'magenta-power',
    name: 'Magenta Power',
    primary: '#A21CAF',
    secondary: '#D946EF',
    background: '#701A75',
    text: '#FAE8FF',
    accent: '#E879F9',
    hover: '#BE185D',
  },
  {
    id: 'bronze-premium',
    name: 'Bronze Premium',
    primary: '#A16207',
    secondary: '#CA8A04',
    background: '#713F12',
    text: '#FFFBEB',
    accent: '#EAB308',
    hover: '#854D0E',
  },
];

// Apply color scheme to the public website only
export const applyWebsiteTheme = (scheme) => {
  const root = document.documentElement;
  
  // Update CSS variables
  root.style.setProperty('--primary', scheme.primary);
  root.style.setProperty('--secondary', scheme.secondary);
  root.style.setProperty('--background', scheme.background);
  root.style.setProperty('--text', scheme.text);
  root.style.setProperty('--accent', scheme.accent);
  root.style.setProperty('--hover', scheme.hover);
  
  // Save to localStorage
  localStorage.setItem('website_color_scheme', JSON.stringify(scheme));
  
  // Trigger a custom event for real-time updates
  window.dispatchEvent(new CustomEvent('websiteThemeChanged', { detail: scheme }));
  
  console.log('Website theme applied:', scheme.name);
};

// Get current color scheme from localStorage
export const getCurrentWebsiteTheme = () => {
  try {
    const stored = localStorage.getItem('website_color_scheme');
    if (stored) {
      const theme = JSON.parse(stored);
      // Ensure hover color exists (for backward compatibility)
      if (!theme.hover) {
        theme.hover = theme.primary;
      }
      return theme;
    }
  } catch (error) {
    console.error('Error loading website theme:', error);
  }
  
  // Return default scheme
  return colorSchemes.find(s => s.id === 'default');
};

// Initialize website theme on page load
export const initializeWebsiteTheme = () => {
  const scheme = getCurrentWebsiteTheme();
  applyWebsiteTheme(scheme);
  return scheme;
};